"use client";

import { useEffect } from "react";
import { RefreshCw } from "lucide-react";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <div className="min-h-screen bg-black text-white font-sans flex items-center justify-center p-4 relative z-10">
            <div className="text-center">
                <h1 className="text-6xl font-bold text-red-500 mb-4">Oops!</h1>
                <h2 className="text-2xl font-bold mb-6">Something went wrong</h2>
                <p className="text-gray-400 mb-8 max-w-md mx-auto">
                    We encountered an unexpected error. Please try again later.
                </p>
                <button
                    onClick={reset}
                    className="inline-flex items-center gap-2 bg-white text-black font-bold px-8 py-3 rounded-xl hover:bg-gray-200 transition-colors"
                >
                    <RefreshCw className="w-5 h-5" />
                    Try Again
                </button>
            </div>
        </div>
    );
}
